import { render, staticRenderFns } from "./myDci.vue?vue&type=template&id=12f33060&scoped=true&"
import script from "./myDci.vue?vue&type=script&lang=js&"
export * from "./myDci.vue?vue&type=script&lang=js&"
import style0 from "./myDci.vue?vue&type=style&index=0&id=12f33060&prod&lang=less&"
import style1 from "./myDci.vue?vue&type=style&index=1&id=12f33060&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f33060",
  null
  
)

export default component.exports